<template>
    <k-page background="bg-white">
        <template v-slot:header>
            <registration-header/>
        </template>
        <k-container class="py-10">
            <div class="max-w-3xl mx-auto flex flex-col">
                <h1 class="text-3xl font-bold max-w-l">{{ $t('registration') }}</h1>

                <div class="flex flex-col" v-if="enableMyInfo && $route.params.step === 'basic-info'">
                    <div class="mt-6 text-l font-medium">
                        {{ $t('newRegisterAsLegalMessage') }}&nbsp;
                          <a href="https://www.kilde.sg/investing/what-does-it-mean-to-be-an-accredited-investor-in-singapore" target="_blank" class="text-primary-500 hover:text-primary-600">Learn more</a>
                    </div>
                    <div class="mt-12 mx-auto">
                        <button class="singpass-button p-4 font-medium" @click.prevent="redirectToSingpass">
                            Sign-up with
                            <img class="mt-2" src="/img/singpass_logo_fullcolours.png" width="230px"
                                 alt="Singpass logo">
                        </button>
                    </div>
                    <div class="mt-2">
                        <p class="w-64 text-xs text-center mx-auto">All Singpass users can apply with Myinfo - a data platform
                            that pulls your personal data across participating government agencies to fill out e-forms.
                            <a href="https://www.singpass.gov.sg/main/individuals/" target="_blank"
                               class="text-primary-500 hover:text-primary-600">Find out more</a></p>
                    </div>
                    <div class="mt-12 horizontal-line">or</div>
                    <h1 class="mt-12 mb-8 text-2xl font-bold max-w-l mx-auto">Sign up with email</h1>
                </div>

                <simple-registration-form
                    v-if="$route.params.step === 'basic-info'"
                    @submit="signUp"
                    :validation="validation"
                />
                <my-info-registration-form
                    class="mt-6"
                    v-if="$route.params.step === 'my-info'"
                    @submit="signUpMyInfo"
                    :validation="validation"
                />
                <div class="mt-6 text-l font-medium">{{ $t('alreadyRegistered') }}
                    <router-link :to="'/login'" class="text-primary-500 hover:text-primary-600"
                                 v-if="['basic-info', 'my-info'].indexOf(this.$route.params.step) >= 0">
                        {{ $t('logIn') }}
                    </router-link>
                </div>
            </div>
        </k-container>
        <template v-slot:footer>
            <k-footer/>
        </template>
    </k-page>
</template>

<script>
import RegistrationHeader from '@investor/components/registration/RegistrationHeader'
import SimpleRegistrationForm from '@product-common/components/registration/SimpleRegistrationForm'
import MyInfoRegistrationForm from '@product-common/components/registration/MyInfoRegistrationForm'

export default {
    components: {
        RegistrationHeader,
        SimpleRegistrationForm,
        MyInfoRegistrationForm
    },
    async mounted () {
        if (this.$authToken()) {
            await this.$fetchInvestorProfile()
            await this.$routeInvestor()
        }
        await this.fetchMyInfoSettings()
    },
    computed: {},
    data () {
        return {
            validation: {
                fieldErrors: {}
            },
            enableMyInfo: false,
            myInfoAuthorizationURL: undefined
        }
    },
    methods: {
        async signUp (form) {
            this.validation = {
                fieldErrors: {}
            }
            try {
                this.$trackGAEvent('registration', 'potentialInvestor');
                form.gaClientId = this.$getGAClientId();
                form.url = window.location.href;
                const resp = await this.$post('public/sign-up', form)
                this.$storeLogin(resp.token)
                await this.$fetchInvestorProfile()
                this.$trackEvent('Investor: registered')
                this.$identify(this.$root.$data.investorProfile)
                this.$trackGAEvent('registration', 'personalData');
                this.$trackGADataLayerEvent('registration-form-success', this.$root.$data.investorProfile.number)
                await this.$routeInvestor()
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    this.validation = error.response.data
                    this.$scrollToErrorField()
                } else {
                    console.log(error)
                }
            }
        },
        async signUpMyInfo (form) {
            this.validation = {
                fieldErrors: {}
            }
            try {
                form.gaClientId = this.$getGAClientId();
                form.url = window.location.href;
                const resp = await this.$post('public/fast-sign-up', form)
                this.$storeLogin(resp.token)
                await this.$fetchInvestorProfile()
                this.$trackEvent('Investor: registered')
                this.$identify(this.$root.$data.investorProfile)
                this.$trackGADataLayerEvent('singpass-success', this.$root.$data.investorProfile.number)
                await this.$routeInvestor()
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    this.validation = error.response.data
                    this.$scrollToErrorField()
                } else {
                    console.log(error)
                }
            }
        },
        async fetchMyInfoSettings () {
            try {
                const resp = await this.$get('public/my-info-settings')
                var url = new URL(resp.authApiUrl)
                url.searchParams.append('client_id', resp.clientId)
                url.searchParams.append('attributes', resp.attributes)
                url.searchParams.append('purpose', resp.purpose)
                url.searchParams.append('state', resp.state)
                url.searchParams.append('redirect_uri', resp.redirectUrl)
                this.myInfoAuthorizationURL = url.href
                this.enableMyInfo = resp.enabled
            } catch (error) {
                console.log(error)
            }
        },
        redirectToSingpass () {
            this.$trackGAEvent('registration', 'regSingPass');
            location.href = this.myInfoAuthorizationURL
        }
    }
}
</script>

<style scoped>
.horizontal-line {
    display: flex;
    flex-direction: row;
}

.horizontal-line:before, .horizontal-line:after {
    content: "";
    flex: 1 1;
    border-bottom-style: solid;
    border-bottom-width: thin;
    margin: auto;
}

.horizontal-line:before {
    margin-right: 20px
}

.horizontal-line:after {
    margin-left: 20px
}

.singpass-button {
    border: 2px solid gray;
    border-radius: 20px;
}

</style>
